"use client"

import styles from "./RadioGroup.module.css"

const RadioGroup = ({ options = [], value, onChange, name, disabled = false, direction = "vertical" }) => {
  const handleChange = (optionValue) => {
    if (disabled) return
    if (onChange) onChange(optionValue)
  }

  const groupClasses = [styles.group, styles[direction]].filter(Boolean).join(" ")

  return (
    <div className={groupClasses} role="radiogroup">
      {options.map((option) => (
        <label key={option.value} className={styles.option}>
          <input
            type="radio"
            className={styles.hiddenInput}
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => handleChange(option.value)}
            disabled={disabled || option.disabled}
          />
          <div
            className={`${styles.radio} ${
              value === option.value ? styles.checked : ""
            } ${disabled || option.disabled ? styles.disabled : ""}`}
          >
            <div className={styles.dot}></div>
          </div>
          <span className={`${styles.label} ${disabled || option.disabled ? styles.disabledLabel : ""}`}>
            {option.label}
          </span>
        </label>
      ))}
    </div>
  )
}

export default RadioGroup
